import { render, staticRenderFns } from "./ProjectSettingsPdfExport.vue?vue&type=template&id=848a93fa&scoped=true"
import script from "./ProjectSettingsPdfExport.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsPdfExport.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsPdfExport.vue?vue&type=style&index=0&id=848a93fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848a93fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('848a93fa')) {
      api.createRecord('848a93fa', component.options)
    } else {
      api.reload('848a93fa', component.options)
    }
    module.hot.accept("./ProjectSettingsPdfExport.vue?vue&type=template&id=848a93fa&scoped=true", function () {
      api.rerender('848a93fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/ProjectSettingsPdfExport.vue"
export default component.exports